module.exports = __webpack_public_path__ + "img/semitrailerRearRightOutline.f1a1dde6.svg";